import React, { useState } from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { BF, FF } from "../lib/constants";

export default function Login() {
  var { user, loading, login, resetPassword } = useAuth();
  var location = useLocation();
  var [email, setEmail] = useState("");
  var [pw, setPw] = useState("");
  var [err, setErr] = useState("");
  var [busy, setBusy] = useState(false);
  // "login" of "reset" (wachtwoord vergeten)
  var [mode, setMode] = useState("login");
  var [info, setInfo] = useState("");

  if (loading) return null;
  if (user) {
    var dest = (location.state && location.state.from) || "/";
    return <Navigate to={dest} replace />;
  }

  async function submitReset(e) {
    e.preventDefault();
    setErr(""); setInfo(""); setBusy(true);
    try {
      await resetPassword(email.trim());
      setInfo("Als dit e-mailadres bij ons bekend is, ontvang je binnen enkele minuten een mail met een link om een nieuw wachtwoord in te stellen. Kijk ook even in je spam.");
    } catch (e2) {
      console.error(e2);
      if (e2.code === "auth/invalid-email") setErr("Dit is geen geldig e-mailadres.");
      else setErr("Versturen mislukt (" + (e2.code || e2.message) + ").");
    }
    setBusy(false);
  }

  async function submit(e) {
    e.preventDefault();
    setErr(""); setInfo(""); setBusy(true);
    try { await login(email, pw); }
    catch (e2) {
      console.error(e2);
      setErr("Inloggen mislukt (" + (e2.code || e2.message) + "). Controleer je e-mailadres en wachtwoord.");
    }
    setBusy(false);
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: FF, background: "#F5F3EE", padding: 16 }}>
      <form onSubmit={mode === "reset" ? submitReset : submit} style={{ background: "#fff", borderRadius: 16, padding: 28, maxWidth: 360, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,.08)" }}>
        <h1 style={{ fontFamily: BF, fontSize: 24, color: "#1C1B19", marginBottom: 4, textAlign: "center", fontWeight: 800 }}>Seizoensplan</h1>
        <p style={{ color: "#888", fontSize: 13, marginBottom: 18, textAlign: "center" }}>{mode === "reset" ? "Vul je e-mailadres in, dan sturen we je een link om een nieuw wachtwoord in te stellen" : "Log in met je trainersaccount"}</p>
        <input type="email" value={email} onChange={function (e2) { setEmail(e2.target.value); }} placeholder="E-mailadres" autoFocus required style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 14, outline: "none", marginBottom: 10, fontFamily: FF, boxSizing: "border-box" }} />
        {mode === "login" && <input type="password" value={pw} onChange={function (e2) { setPw(e2.target.value); }} placeholder="Wachtwoord" required style={{ width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 14, outline: "none", marginBottom: 10, fontFamily: FF, boxSizing: "border-box" }} />}
        {err && <p style={{ color: "#E53E3E", fontSize: 12, marginBottom: 8 }}>{err}</p>}
        <button type="submit" disabled={busy} style={{ width: "100%", padding: 10, borderRadius: 8, background: "#1A2744", color: "#fff", border: "none", cursor: busy ? "default" : "pointer", fontSize: 14, fontWeight: 700, opacity: busy ? .7 : 1 }}>{busy ? "Bezig..." : (mode === "reset" ? "Stuur resetlink" : "Inloggen")}</button>
        {info && <p style={{ color: "#38A169", fontSize: 12, marginTop: 10, lineHeight: 1.5 }}>{info}</p>}
        <button type="button" onClick={function () { setMode(mode === "reset" ? "login" : "reset"); setErr(""); setInfo(""); }} style={{ display: "block", margin: "12px auto 0", background: "none", border: "none", color: "#888", fontSize: 12, cursor: "pointer", textDecoration: "underline", fontFamily: FF }}>{mode === "reset" ? "← Terug naar inloggen" : "Wachtwoord vergeten?"}</button>
        {mode === "login" && <p style={{ textAlign: "center", marginTop: 16, paddingTop: 14, borderTop: "1px solid #eee", fontSize: 12, color: "#999" }}>Nog geen account? <Link to="/pakketten" style={{ color: "#1C1B19", fontWeight: 700 }}>Kies een pakket</Link></p>}
        <Link to="/" style={{ display: "block", textAlign: "center", marginTop: 12, color: "#888", fontSize: 12 }}>← Naar de startpagina</Link>
      </form>
    </div>
  );
}
